import request from '@/utils/request'



// 查询订单发货记录列表
export function listDelivery(query) {
  return request({
    url: '/order/delivery/list',
    method: 'get',
    params: query
  })
}

// 查询订单发货记录分页
export function pageDelivery(query) {
  return request({
    url: '/order/delivery/page',
    method: 'get',
    params: query
  })
}

//物流信息
export function logisticsById(data) {
  return request({
    url: '/order/delivery/logistics/id',
    method: 'get',
    params: data
  })
}

export function logisticsByNo(data) {
  return request({
    url: '/order/delivery/logistics/no',
    method: 'get',
    params: data
  })
}


// 查询订单发货记录详细
export function getDelivery(data) {
  return request({
    url: '/order/delivery/detail',
    method: 'get',
    params: data
  })
}


